import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default:
          "flex justify-center items-center px-[16px] text-white rounded-[70px] border-[1px] border-white/40 bg-[#3B3B3B1A] font-minion",
        answer:
          "flex flex-col w-full justify-center items-center gap-[10px] bg-[#3B3B3B1A] text-white rounded-[8px] border-[1px] border-white/40 font-minion whitespace-normal p-[12px] active:border-none active:rounded-[4px] active:bg-[#A8000C]",
        back: "inline-flex h-[36px] px-[16px] justify-center items-center gap-[8px] shrink-0 rounded-[2px] border border-white/40 bg-[#3B3B3B66] backdrop-blur-[2px] font-minion",
        primary:
          "flex justify-center items-center px-[16px] text-white rounded-[70px] bg-primary font-minion",
        discover:
          "flex justify-center items-center px-[16px] rounded-[70px] border border-[#05050566] bg-[#0505051A] font-minion",
      },
      size: {
        default: "h-10 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Button, buttonVariants };
